import type { ReactElement } from "react";
import { ErrorListItem } from "./ErrorListItem";
import { selectCode, useRankedProblems } from "./store";
import styles from "./ErrorList.module.css";

export function ErrorList(): ReactElement {
  const ranked = useRankedProblems();
  return (
    <div className={styles.list}>
      {ranked.map(({ problem, codeMatches, titleMatches }) => (
        <ErrorListItem
          key={problem.code}
          problem={problem}
          codeMatches={codeMatches}
          titleMatches={titleMatches}
          onSelect={() => selectCode(problem.code)}
        />
      ))}
    </div>
  );
}
